import type { BreadcrumbItem } from '@/components/common/Breadcrumb/BreadcrumbBuilder';

export interface RouteBreadcrumbConfig {
    path: string;
    label: string;
    parent?: string; // Reference to parent route path
    children?: string[]; // Array of child route paths
}

// Route configuration with breadcrumb mappings
export const routeBreadcrumbConfig: Record<string, RouteBreadcrumbConfig> = {
    // Main sections (no breadcrumbs needed)
    '/profile': { path: '/profile', label: 'Profile' },
    '/system': { path: '/system', label: 'System Management' },
    '/companies': { path: '/companies', label: 'Companies' },
    '/usermanagement/groups': { path: '/usermanagement/groups', label: 'Groups' },
    '/usermanagement/users': { path: '/usermanagement/users', label: 'Users' },
    '/programmanagement/templates': { path: '/programmanagement/templates', label: 'Course Templates' },
    '/programmanagement/courses': { path: '/programmanagement/courses', label: 'Courses' },
    '/programmanagement/programs': { path: '/programmanagement/programs', label: 'Programmes' },
    '/contentmanagement/assessments': { path: '/contentmanagement/assessments', label: 'Assessments' },
    '/contentmanagement/trainings': { path: '/contentmanagement/trainings', label: 'Trainings' },
    '/contentmanagement/nutrition': { path: '/contentmanagement/nutrition', label: 'Nutrition' },

    // Nested pages (need breadcrumbs)
    '/programmanagement/programs/add-assessment-run': {
        path: '/programmanagement/programs/add-assessment-run',
        label: 'Add New Assessment Run',
        parent: '/programmanagement/programs',
    },
};

/**
 * Get breadcrumbs for a given route path
 * Returns null for main pages (no breadcrumbs needed)
 * Returns breadcrumb array for nested pages
 */
export const getBreadcrumbsForRoute = (pathname: string): BreadcrumbItem[] | null => {
    const routeConfig = routeBreadcrumbConfig[pathname];

    if (!routeConfig) {
        return null; // Unknown route, no breadcrumbs
    }

    // If no parent, this is a main page - no breadcrumbs needed
    if (!routeConfig.parent) {
        return null;
    }

    const parentConfig = routeBreadcrumbConfig[routeConfig.parent];
    if (!parentConfig) {
        return null; // Parent not found, fallback to no breadcrumbs
    }

    // Return breadcrumb array: [Parent, Current]
    return [
        { label: parentConfig.label, href: parentConfig.path },
        { label: routeConfig.label, isCurrentPage: true },
    ];
};
